.form {
  padding: 0;
  container-type: inline-size;
}

/* Two fields side by side when the form is wide. A row with one field leaves the right column empty. */
.fieldRow {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  column-gap: 2rem;
  margin-top: 1rem;
}

/* Each cell is a subgrid over the row's four tracks: label, field, error and info text. The fields then start
   at the same height, however long the labels are and whether they have a help icon.
   Doubled to beat .container:first-of-type in Input. */
.fieldRow.fieldRow > :nth-child(n) {
  display: grid;
  grid-row: span 4;
  grid-template-rows: subgrid;
  margin-block: 0;
  padding-block: 0;
}

/* A field keeps its own height and is not stretched to the tallest field in the row. */
.fieldRow > * > :is(input, select, textarea) {
  align-self: start;
}

/* The help box opens over the field, as it does outside a row. */
.fieldRow > * > [role="note"] {
  grid-row: 2;
}

/* The forms take 8 of 12 columns, like the main column on the dashboard. At 1280px that is about 620px, and
   about 555px inside a card, so the limit sits below that. */
@container (min-width: 34rem) {
  .fieldRow {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

.row {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  gap: 3rem;
}

.column {
  flex: 1 1 18rem;
  min-width: 0;
}

.section {
  margin: 1rem 0;
}

.actions {
  margin-top: 2rem;
}

.clickable {
  cursor: pointer;
}

.textButton {
  padding: 0;
  border: 0;
  background: none;
  color: inherit;
  font: inherit;
  text-align: left;
  cursor: pointer;
}

.selectedLabel {
  margin: 0 0 0.25rem;
  font-weight: 700;
}

.headerRow {
  display: flex;
  width: 100%;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
}

.headerAside {
  min-width: 150px;
  margin-top: 58px;
}

/* On a phone the coach goes under the heading instead of past the screen edge. */
@media (max-width: 40rem) {
  .headerRow {
    flex-wrap: wrap;
  }

  .headerAside {
    margin-top: 0;
  }
}

.receipt {
  padding: 0.5rem;
  border: 3px solid #1c5b01;
}

.cardSection {
  margin-bottom: 2rem;
}

.mediaRow {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 1rem;
  padding: 0.5rem 0;
}

.note {
  min-height: 0.5rem;
  margin-top: 0.5rem;
}

.helpText {
  margin: 0.5rem 0 0;
  color: var(--color-text-muted);
  font-size: 0.875rem;
  font-style: italic;
  text-align: center;
}

.compactContainer {
  margin: 0;
}

.compactField {
  margin-bottom: 0;
}

.inlineLink {
  margin-left: 1rem;
  font-size: 0.75rem;
  font-weight: 400;
  text-decoration: underline;
  cursor: pointer;
}

.headingAction {
  display: inline-flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.25rem;
}

.buttonContainer {
  margin-top: 1rem;
  & :first-child {
    margin-left: 0;
  }
  & :not(:first-child) {
    margin-left: 2rem;
  }
}
